import { render, staticRenderFns } from "./tree-table.vue?vue&type=template&id=bb11c16e&"
import script from "./tree-table.vue?vue&type=script&lang=js&"
export * from "./tree-table.vue?vue&type=script&lang=js&"
import style0 from "./tree-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports